import { render } from "./ContentAppUrl.vue?vue&type=template&id=2646d2a0"
import script from "./ContentAppUrl.vue?vue&type=script&lang=js"
export * from "./ContentAppUrl.vue?vue&type=script&lang=js"

import "./ContentAppUrl.vue?vue&type=style&index=0&id=2646d2a0&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__